import { useTestMetricRuntime } from "../contexts"

export const useCanRunEvaluations = (): boolean => {
  const { metric } = useTestMetricRuntime()
  return !!metric?.id
}
